module.exports = __webpack_public_path__ + "static/media/kids-class-creed.269ef2ff.jpg";